var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgendaNoShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08642 11.9114C4.31843 12.1434 4.61231 12.2517 4.90619 12.2517C5.20007 12.2517 5.49395 12.1434 5.72596 11.9114L7.99967 9.63766L10.2734 11.9114C10.5054 12.1434 10.7993 12.2517 11.0932 12.2517C11.387 12.2517 11.6809 12.1434 11.9129 11.9114C12.3615 11.4628 12.3615 10.7204 11.9129 10.2718L9.63922 7.99812L11.9129 5.72441C12.3615 5.27585 12.3615 4.53341 11.9129 4.08486C11.4644 3.6363 10.7219 3.6363 10.2734 4.08486L7.99967 6.35857L5.72596 4.08486C5.27741 3.6363 4.53497 3.6363 4.08642 4.08486C3.63786 4.53341 3.63786 5.27585 4.08642 5.72441L6.36013 7.99812L4.08642 10.2718C3.63786 10.7204 3.63786 11.4628 4.08642 11.9114Z",
    fill: "#D04345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaNoShow);
export default __webpack_public_path__ + "static/media/agenda-no-show.bb52352c03f730fee4a9a79fc61eca17.svg";
export { ForwardRef as ReactComponent };